import styled from 'styled-components';
import { white, primary, neutral } from '../../../style/colors';

export const ExpandedSection = styled.div`
  border-top: 1px solid ${neutral[200]};
  padding-top: 8px;
  margin-top: 8px;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

export const ExpandedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  margin-bottom: 8px;
`;

export const InfoCard = styled.div`
  background: ${neutral[50]};
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid ${neutral[200]};
  max-width: 300px;
`;

export const InfoLabel = styled.div`
  font-size: 9px;
  color: ${neutral[500]};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
  font-weight: 600;
`;

export const InfoValue = styled.div`
  font-size: 12px;
  color: ${neutral[700]};
  font-weight: 600;
`;

export const PriceAccordion = styled.div`
  grid-column: 1 / -1;
  border: 2px solid ${primary[500]};
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
  max-width: 300px;
`;

export const PriceAccordionHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: ${primary[50]};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
  font-weight: 700;
  color: ${primary[700]};
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: ${primary[100]};
  }

  i {
    font-size: 18px;
    color: ${primary[500]};
    transition: transform 0.3s ease;
  }

  .chevron {
    margin-left: auto;
  }
`;

export const PriceAccordionContent = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'grid' : 'none')};
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
  padding: 12px;
  background: ${white};
  border-top: 1px solid ${primary[200]};
`;

export const LinksRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ExternalLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: ${neutral[100]};
  border: 1px solid ${neutral[200]};
  border-radius: 3px;
  color: ${neutral[500]};
  text-decoration: none;
  font-size: 10px;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    background: ${neutral[200]};
    border-color: ${primary[500]};
    color: ${primary[500]};
  }

  i { font-size: 12px; }
`;

export const ViewDetailsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: ${primary[500]};
  border: 1px solid ${primary[500]};
  border-radius: 4px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${primary[600]};
    border-color: ${primary[600]};
  }

  i { font-size: 14px; }
`;

export const ProductInfoTags = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const Tag = styled.span`
  background-color: ${neutral[100]};
  color: ${neutral[500]};
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
  border: 1px solid ${neutral[200]};
`;
